<!-- Principalmente las secciones están definidas para corresponder a Cumplimiento, Resultado y Meta, pero el título puede variar -->
<li class="collection-item" apply="theme" background="section" [ngClass]="{'scale-lightness': important}">
  <!-- Sección para el título del indicador (cumplimiento) -->
  <div class="row margin-all-0" apply="theme" color="body">
    <p class="col s12 m12 l12 padding-all-0 fnt-14-i" [ngClass]="{'text-ghost': !titleF, 'bld': boldText[0]}">
      {{titleF ? titleF : 'Lorem ipsum dolor sit.'}}
      <ng-container *ngIf="tooltipPosition == 1">
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
      </ng-container>
    </p>
  </div>
  <div class="row margin-all-0" apply="theme" color="body">
    <!-- Sección para el título del indicador (resultado) -->
    <p class="col s6 m6 l6 padding-all-0 text-not-break" style="text-align: left;"
      [ngClass]="{'text-ghost': !titleR, 'bld': boldText[1],'fnt-14-i':importantFont,'fnt-12-i':!importantFont}">
      {{titleR ? titleR : 'Lorem ipsum dolor sit.'}}
      <ng-container *ngIf="tooltipPosition == 2">
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
      </ng-container>
    </p>
    <!-- Sección para el título del indicador (meta) -->
    <p class="col s6 m6 l6 padding-all-0 text-not-break" style="text-align: right;"
      [ngClass]="{'text-ghost': !titleG, 'bld': boldText[1],'fnt-14-i':importantFont,'fnt-12-i':!importantFont}">
      {{titleG ? titleG : 'Lorem ipsum dolor sit.'}}
      <ng-container *ngIf="tooltipPosition == 3">
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
      </ng-container>
    </p>
  </div>
  <div class="row margin-all-0" apply="theme" color="body">
    <!-- sección para el valor del indicador (resultado) -->
    <p class="col s6 m6 l6 margin-top-0 padding-all-0"
      [ngClass]="{'bld': boldText[2],'fnt-13-i':importantFont,'fnt-11-i':!importantFont}" style="text-align: left;">
      {{result}}
      <ng-container *ngIf="tooltipPosition == 4">
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
      </ng-container>
    </p>
    <!-- sección para el valor del indicador (meta) -->
    <p class="col s6 m6 l6 margin-top-0 padding-all-0"
      [ngClass]="{'bld': boldText[2],'fnt-13-i':importantFont,'fnt-11-i':!importantFont}" style="text-align: right;">
      {{goal}}
      <ng-container *ngIf="tooltipPosition == 5">
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
      </ng-container>
    </p>
  </div>
  <!-- sección para el valor del indicador (cumplimiento) -->
  <div style="position: relative;" *ngIf="!notF">
    <span class="badge margin-all-0 recovery-badges" [ngStyle]="{'width': (fulfillment | setPercentage:true) + '%'}"
      [attr.data-badge-caption]="message" [ngClass]="{'not-decimals': decimalsInFulfillment == 0}"
      *ngIf="fulfillment >= 0">{{fulfillment | setPercentage:false:decimalsInFulfillment}}%</span>
    <div class="progress margin-top-5 margin-bottom-5 scale-lightness" apply="theme"
      [attr.background]="((fulfillment >= 0 ? fulfillment : random)) | setAlertType:setAlert">
      <div class="determinate determinate-gradient" apply="theme"
        [attr.background]="((fulfillment >= 0 ? fulfillment : random)) | setAlertType:setAlert"
        [ngStyle]="{'width': ((fulfillment >= 0 ? fulfillment : random) | setPercentage:true) + '%'}">
      </div>
    </div>
  </div>
</li>
<!-- Sección para los tooltips cuando sean necesarios -->
<ng-template #tooltipTemplate>
  <a *ngIf="tooltipText" class="tooltip-hover btn-flat auto-height"
    style="line-height: inherit;padding: 0;text-transform: inherit;">
    <i class="material-icons fnt-13-i scale-lightness" apply="theme" color="background" style="line-height: 13px;"
      (mouseover)="prettyTooltip.setTooltip((tooltipTitle ? tooltipTitle : titleF), tooltipText, tooltipDirection, $event.target)"
      (mouseout)="prettyTooltip.setTooltip()">help</i>
  </a>
</ng-template>